(function () {
'use strict';
var dlT = function (k, f) { var d = window.DL_I18N; return (d && d[k] != null) ? d[k] : f; };
/* De Leville theme copy of deleville-mockups/engrave-runtime.js (v4). One change: it loads only
   the plate of the gold on the page, and another when setGold() asks for it. */
/* ═══════════════════════════════════════════════════════════════════════════════
   De Leville engraving preview — runtime (long form: engrave-RULES.md)

   1. The plate is the FRONT view: it looks down the ring's axis, so the engraved side
      face is a true circle. Glyphs are placed by PURE ROTATION about one centre. There
      is no lean, shear or squeeze anywhere in this file, and there must never be.
   2. Ring coordinates only. An engraving is (theta, r); theta decreases along reading
      direction; glyph tops point at the centre.
   3. The cut is a RATIO of the render's own pixel, from a table learned off the real
      maker's mark in this same view, per gold (engrave-tools/learn_cut.py):
          out = plate × T(v, phi)      v = blurred ink mask, phi = which way the wall faces
      No paint, no hex colour, no outline, no shadow, no blend mode.
   4. Same hand as the mark: same baseline radius, same cap height, and every lowercase e
      IS the mark's own e (LOGO_E, traced off the render). Capitals are never tilted.
   5. Spaces. The band is divided by notches 72 degrees apart. The mark has one space;
      each engraving takes the next, sitting as far past its notch as the mark sits
      before 6 o'clock:  De Leville · notch · first · notch · second.
   6. The arc is the limit: anchor → slide toward the notch → shrink to a 75% floor →
      refuse further letters. An engraving never crosses a notch.
   7. If anything is missing, the loupe stays hidden. Never a sticker fallback.
   ═══════════════════════════════════════════════════════════════════════════════ */

// The theme's own Futura PT (full Latin + Cyrillic), next to this script. The "Futura Cyrillic" files have no
// accented Latin, and a FontFace added here outranks the page's @font-face, so they must not come back (24 Sep).
const DL_ASSET_BASE = (document.currentScript && document.currentScript.src) || '';
const FONT_URLS = DL_ASSET_BASE ? {
  500: new URL('FuturaPT-Medium.woff', DL_ASSET_BASE).href,
  400: new URL('FuturaPT-Book.woff', DL_ASSET_BASE).href,
} : {
  500: 'https://cdn.shopify.com/s/files/1/0733/5064/3879/files/FuturaCyrillicMedium.woff?v=1767543748',
  400: 'https://cdn.shopify.com/s/files/1/0733/5064/3879/files/FuturaCyrillicBook.woff?v=1767543748',
};
const METALS = [
  { key:'rose',   label:'Rose Gold',   hi:'#f6d2c2', mid:'#c88d75', lo:'#8a5440' },
  { key:'yellow', label:'Yellow Gold', hi:'#f4dc9c', mid:'#c89b3c', lo:'#836018' },
  { key:'white',  label:'White Gold',  hi:'#fdfdfc', mid:'#dcdcd7', lo:'#a2a49f' },
];
/* The De Leville e, as a stroked centreline in its own 46x50 box (origin top-left, y down).
   All three e's in the mark are the same drawing. engrave-e-fit.html overlays this on it. */
const LOGO_E = {
  w: 46, h: 50, stroke: 10, barStroke: 8.4,
  bowl: [[41.5,45.2],[32,45.8],[22,44.6],[13.2,40.2],[7.2,33.6],[4.8,26],[6.2,17.6],[11.6,10.6],[20,6],[30,4.7],[42.6,5.2]],
  bar:  [[43.4,2.2],[14.6,38.2]],
};
const isHouseE = ch => ch === 'e';
const TRACK = 0.045, MIN_SCALE = 0.75;
const ALLOWED = /[^A-Za-zÀ-ÖØ-öø-ÿ0-9 '’.\-&·]/g;

window.DeLevilleEngraver = function (opts) {
/* opts: { loupe, canvas, note, inputs:[el, el], dataUrl, plateUrl(gold), gold, weight, onChange } */
const state = { data:null, plates:{}, gold: opts.gold || 'rose', weight: opts.weight || 500, capRatio:{} };
/* Where the plate sits in the render: origin in render px (3500-wide), and plate px per render px.
   A loupe crop is {origin:[990,1030], scale:1}; the whole product picture at 1500 px is
   {origin:[0,0], scale:1500/3500}. All geometry stays in render units; only drawing is scaled. */
const PLATE = Object.assign({ origin: [0, 0], scale: 1 }, opts.plate || {});
const els = { loupe: opts.loupe, view: opts.canvas, note: opts.note };
const $ = id => els[id];

/* ── the house e, sized to the font's x-height and stroked at the font's stem ─── */
function eMetrics(ctx) {
  const xh = ctx.measureText('x').actualBoundingBoxAscent;
  const l = ctx.measureText('l'), stem = l.actualBoundingBoxLeft + l.actualBoundingBoxRight;
  const k = xh * 1.035 / LOGO_E.h, side = stem * 0.62;
  return { k, stem, drop: k * 0.9, advance: LOGO_E.w * k + side * 2 };
}
function drawHouseE(ctx, em) {
  const E = LOGO_E, k = em.k, P = E.bowl;
  ctx.save();
  ctx.translate(-E.w * k / 2, em.drop - E.h * k); ctx.scale(k, k);
  ctx.lineCap = 'butt'; ctx.lineJoin = 'round'; ctx.strokeStyle = '#000';
  ctx.beginPath(); ctx.moveTo(P[0][0], P[0][1]);
  for (let i = 0; i < P.length - 1; i++) {
    const p0 = P[Math.max(0, i - 1)], p1 = P[i], p2 = P[i + 1], p3 = P[Math.min(P.length - 1, i + 2)];
    ctx.bezierCurveTo(p1[0] + (p2[0] - p0[0]) / 6, p1[1] + (p2[1] - p0[1]) / 6,
                      p2[0] - (p3[0] - p1[0]) / 6, p2[1] - (p3[1] - p1[1]) / 6, p2[0], p2[1]);
  }
  ctx.lineWidth = em.stem / k; ctx.stroke();
  ctx.beginPath(); ctx.moveTo(E.bar[0][0], E.bar[0][1]); ctx.lineTo(E.bar[1][0], E.bar[1][1]);
  ctx.lineWidth = em.stem / k * (E.barStroke / E.stroke); ctx.stroke();
  ctx.restore();
}

/* ── layout in ring coordinates, inside one space ───────────────────────────── */
function layout(ctx, text, weight, space) {
  const D = state.data, rBase = D.mark.r_base, capTarget = D.mark.r_base - D.mark.r_top;
  const room = space.theta_from - space.theta_to;

  const measure = (scale) => {
    const px = capTarget / state.capRatio[weight] * scale;
    ctx.font = `${weight} ${px}px "Futura PT"`;
    const track = px * TRACK, xs = [0], em = eMetrics(ctx);
    for (let i = 0; i < text.length; i++) {
      const ch = text[i], nx = text[i + 1];
      let a;
      if (isHouseE(ch)) a = em.advance;
      else if (nx && !isHouseE(nx)) a = ctx.measureText(ch + nx).width - ctx.measureText(nx).width;   // keeps pair kerning
      else a = ctx.measureText(ch).width;
      xs.push(xs[i] + a + track);
    }
    const len = xs[text.length] - track;
    return { px, xs, len, em, track, span: len / rBase * 180 / Math.PI };
  };

  // Text metrics do not scale perfectly linearly with font size (hinting, rounding), so
  // aim a hair inside the room and allow a hair of tolerance — otherwise a name that fits
  // at 0.93 lands at 1.0004 of the room and gets its last letter refused.
  let scale = 1, m = measure(scale);
  if (m.span > room) { scale = Math.max(MIN_SCALE, room / m.span * 0.994); m = measure(scale); }
  if (m.span > room * 1.004) return null;

  let start = space.centre + m.span / 2;
  if (start - m.span < space.theta_to) start = space.theta_to + m.span;       // would cross the far notch: slide back
  if (start > space.theta_from) start = space.theta_from;

  // Descenders. The face is only ~112 render px tall and the mark's baseline sits 18 px
  // above the pavé, so a p or a y would drop into the stones. Lift the baseline by what
  // the descender needs; if the word then no longer clears the inner edge, shrink it.
  const INK_TOP = D.mark.r_top - 8, INK_BOT = D.ink_bot || (D.mark.r_base + 18);   // Puro's plain face has more room below than Essenza's pavé
  let px = m.px, rb = rBase;
  ctx.font = `${weight} ${px}px "Futura PT"`;
  let mt = ctx.measureText(text), asc = mt.actualBoundingBoxAscent, desc = mt.actualBoundingBoxDescent;
  if (desc > INK_BOT - rBase) {
    const need = asc + desc, have = INK_BOT - INK_TOP;
    if (need > have) { scale *= have / need; m = measure(scale); px = m.px; ctx.font = `${weight} ${px}px "Futura PT"`;
      mt = ctx.measureText(text); asc = mt.actualBoundingBoxAscent; desc = mt.actualBoundingBoxDescent; }
    rb = Math.min(rBase, INK_BOT - desc - 1);
  }

  const glyphs = [];
  for (let i = 0; i < text.length; i++) {
    const mid = (m.xs[i] + m.xs[i + 1] - m.track) / 2;
    glyphs.push({ ch: text[i], theta: start - (mid / rBase) * 180 / Math.PI });
  }
  return { glyphs, px: m.px, em: m.em, scale, rBase: rb };
}

/* ── ink mask: rigid glyphs, pure rotation, tops to the centre ──────────────── */
function drawMask(ctx, L, weight) {
  const D = state.data, [ox, oy] = PLATE.origin, S = PLATE.scale, rBase = L.rBase;
  ctx.setTransform(1, 0, 0, 1, 0, 0);
  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
  ctx.font = `${weight} ${L.px}px "Futura PT"`;
  ctx.textAlign = 'center'; ctx.textBaseline = 'alphabetic'; ctx.fillStyle = '#000';
  let x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9;
  for (const g of L.glyphs) {
    const t = g.theta * Math.PI / 180, gx = (D.cx + rBase * Math.cos(t) - ox) * S, gy = (D.cy + rBase * Math.sin(t) - oy) * S;
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.translate(gx, gy); ctx.rotate(t - Math.PI / 2); ctx.scale(S, S);
    if (isHouseE(g.ch)) drawHouseE(ctx, L.em); else ctx.fillText(g.ch, 0, 0);
    x0 = Math.min(x0, gx); y0 = Math.min(y0, gy); x1 = Math.max(x1, gx); y1 = Math.max(y1, gy);
  }
  ctx.setTransform(1, 0, 0, 1, 0, 0);
  // the ink's box is known from where the glyphs were put — never scan the canvas for it
  const reach = Math.ceil(L.px * 1.15 * S) + 8, W = ctx.canvas.width, H = ctx.canvas.height;
  return { x: Math.max(0, Math.floor(x0 - reach)), y: Math.max(0, Math.floor(y0 - reach)),
           x1: Math.min(W, Math.ceil(x1 + reach)), y1: Math.min(H, Math.ceil(y1 + reach)) };
}

/* ── the cut: out = plate × T(depth, phi), inside the ink's box only ────────── */
/* Depth is distance from the groove's edge in px (inside positive), recovered from the
   blurred mask with the inverse normal CDF — the same mapping learn_cut.py bins by. Binning
   by the blurred value itself lumped the wall's shadow in with the floor and made a wide
   Futura stroke's floor 3% darker than the mark's. */
function erfinv(x) { const a = 0.147, l = Math.log(1 - x * x), t = 2 / (Math.PI * a) + l / 2;
  return Math.sign(x) * Math.sqrt(Math.sqrt(t * t - l / a) - t); }
function depthBin(v) { const D = state.data, x = Math.min(0.999999, Math.max(-0.999999, 2 * v - 1));
  return Math.min(D.nv - 1, Math.max(0, (D.sigma * Math.SQRT2 * erfinv(x) - D.dbins.d0) / D.dbins.step - 0.5)); }
/* The blur runs at plate resolution (sigma × scale) so depth still reads in render px — the
   same cut, rescaled, which is exactly what the maker's mark in a downscaled picture is. */
let KERNEL = null;
function kernel(sigma) {
  if (KERNEL) return KERNEL;
  const r = Math.ceil(sigma * 3), k = new Float32Array(2 * r + 1); let s = 0;
  for (let i = -r; i <= r; i++) { k[i + r] = Math.exp(-i * i / (2 * sigma * sigma)); s += k[i + r]; }
  for (let i = 0; i < k.length; i++) k[i] /= s;
  return (KERNEL = { k, r });
}
function applyCut(view, maskCtx, table, box) {
  const D = state.data, NV = D.nv, w = box.x1 - box.x, h = box.y1 - box.y;
  if (w < 3 || h < 3) return;
  const A = maskCtx.getImageData(box.x, box.y, w, h).data;
  const m = new Float32Array(w * h); for (let i = 0; i < w * h; i++) m[i] = A[i * 4 + 3] / 255;

  const { k, r } = kernel(Math.max(0.5, D.sigma * PLATE.scale)), tmp = new Float32Array(w * h), v = new Float32Array(w * h);
  for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) { let s = 0;
    for (let i = -r; i <= r; i++) { const xx = Math.min(w - 1, Math.max(0, x + i)); s += m[y * w + xx] * k[i + r]; } tmp[y * w + x] = s; }
  for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) { let s = 0;
    for (let i = -r; i <= r; i++) { const yy = Math.min(h - 1, Math.max(0, y + i)); s += tmp[yy * w + x] * k[i + r]; } v[y * w + x] = s; }

  const img = view.getImageData(box.x, box.y, w, h), P = img.data;
  for (let y = 1; y < h - 1; y++) for (let x = 1; x < w - 1; x++) {
    const i = y * w + x, vv = v[i];
    if (vv <= 0.004) continue;
    const gx = (v[i + 1] - v[i - 1]) / 2, gy = (v[i + w] - v[i - w]) / 2;
    const wt = Math.min(1, Math.hypot(gx, gy) / (0.08 * PLATE.scale)), phi = Math.atan2(gy, gx);
    const c1 = Math.cos(phi) * wt, s1 = Math.sin(phi) * wt, c2 = Math.cos(2 * phi) * wt, s2 = Math.sin(2 * phi) * wt;
    const pos = depthBin(vv), i0 = Math.floor(pos), i1 = Math.min(NV - 1, i0 + 1), f = pos - i0;
    const T0 = table[i0], T1 = table[i1];
    for (let c = 0; c < 3; c++) {
      const R = (T0[0][c] * (1 - f) + T1[0][c] * f)
              + (T0[1][c] * (1 - f) + T1[1][c] * f) * c1 + (T0[2][c] * (1 - f) + T1[2][c] * f) * s1
              + (T0[3][c] * (1 - f) + T1[3][c] * f) * c2 + (T0[4][c] * (1 - f) + T1[4][c] * f) * s2;
      P[i * 4 + c] = Math.max(0, Math.min(255, P[i * 4 + c] * R));
    }
  }
  view.putImageData(img, box.x, box.y);
}

/* ── wiring ─────────────────────────────────────────────────────────────────── */
const view = els.view.getContext('2d', { willReadFrequently: true });
const maskCanvas = document.createElement('canvas'); maskCanvas.width = els.view.width; maskCanvas.height = els.view.height;
const maskCtx = maskCanvas.getContext('2d', { willReadFrequently: true });
const inputs = opts.inputs;

function fit(input, space) {
  // the arc is the limit, not a character count: refuse the letters that do not fit
  let text = input.value.replace(ALLOWED, ''), L = text.trim() ? layout(maskCtx, text, state.weight, space) : null;
  while (text.trim() && !L) { text = text.slice(0, -1); L = text.trim() ? layout(maskCtx, text, state.weight, space) : null; }
  if (text !== input.value) { const at = input.selectionStart; input.value = text; try { input.setSelectionRange(at, at); } catch (e) {} }
  return L;
}
function render() {
  const plate = state.plates[state.gold], table = state.data && state.data.tables_d && state.data.tables_d[state.gold];
  if (!plate || !table || !state.capRatio[state.weight] || !(state.data.spaces || []).length) { if ($('loupe')) $('loupe').hidden = true; return; }
  if ($('loupe')) $('loupe').hidden = false;
  view.drawImage(plate, 0, 0);
  let shrunk = false, second = false;
  inputs.forEach((input, i) => {
    const space = state.data.spaces[i]; if (!space || !input || input.disabled) return;
    const L = fit(input, space); if (!L) return;
    const box = drawMask(maskCtx, L, state.weight);
    applyCut(view, maskCtx, table, box);
    shrunk = shrunk || L.scale < 0.999; second = second || i === 1;
  });
  if ($('loupe')) $('loupe').classList.toggle('tall', second);
  if ($('note')) $('note').textContent = shrunk ? dlT('lillo.sized_to_fit_band_note', 'sized to fit the band') : '';
  if (opts.onChange) opts.onChange({ second, shrunk });
}

function loadPlate(g) {
  if (state.plates[g]) return Promise.resolve(state.plates[g]);
  return new Promise((ok, bad) => {
    const im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = () => { state.plates[g] = im; ok(im); }; im.onerror = bad;
    im.src = opts.plateUrl(g);
  });
}
async function boot() {
  try {
    state.data = await (await fetch(opts.dataUrl)).json();
    await Promise.all(Object.entries(FONT_URLS).map(async ([w, url]) => {
      const f = new FontFace('Futura PT', `url(${url})`, { weight: w }); await f.load(); document.fonts.add(f);
      maskCtx.font = `${w} 1000px "Futura PT"`;
      state.capRatio[w] = maskCtx.measureText('H').actualBoundingBoxAscent / 1000;
    }));
    await loadPlate(state.gold);          // only the gold on the page; another loads when it is chosen
  } catch (err) { console.warn('engraving preview unavailable', err); if ($('loupe')) $('loupe').hidden = true; return; }
  render();
}

let raf = 0;
inputs.forEach(inp => inp && inp.addEventListener('input', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(render); }));
boot();
return {
  render,
  setGold(g) { state.gold = g; if (state.plates[g]) render(); else loadPlate(g).then(render, () => {}); },
  ready() { return !!(state.data && state.plates[state.gold] && state.capRatio[state.weight]); },
  setWeight(w) { state.weight = +w; render(); },
  state,
};
};
})();
